
export const ModalBody = ({children}) => {
    return(
        <div className="m-7 overflow-hidden flex flex-col gap-2">
         {children}
        </div>
    )
} 